import React from 'react';

function SchemaOrg() {
  const organizationData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Ulpian AI',
    url: 'https://ulpian.com',
    sameAs: ['https://www.linkedin.com/company/ulpian-ai'],
    logo: 'https://ulpian.com/logo.png',
    description:
      'We combine expertise in law, AI, and software engineering to seamlessly integrate technology with legal practices.',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'info@ulpian.com',
      contactType: 'customer service',
      availableLanguage: ['English', 'Croatian', 'German']
    }
  };

  const legalServiceData = {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    name: 'Ulpian AI Legal Research Platform',
    provider: {
      '@type': 'Organization',
      name: 'Ulpian AI'
    },
    description: 'AI-powered legal research platform for EU, Croatian, and Austrian law. Search legislation, case law, and analyze legal documents.',
    url: 'https://ulpian.com',
    areaServed: [
      {
        '@type': 'Country',
        name: 'Croatia'
      },
      {
        '@type': 'Country',
        name: 'Austria'
      },
      {
        '@type': 'AdministrativeArea',
        name: 'European Union'
      }
    ],
    serviceType: [
      'Legal Research',
      'Case Law Analysis',
      'Document Analysis',
      'Regulatory Compliance'
    ],
    availableChannel: {
      '@type': 'ServiceChannel',
      serviceUrl: 'https://app.ulpian.com',
      serviceLocation: {
        '@type': 'Place',
        name: 'Online Platform'
      }
    }
  };

  const websiteData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Ulpian AI',
    url: 'https://ulpian.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://app.ulpian.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  };

  const schemaData = [organizationData, legalServiceData, websiteData];

  return <script type="application/ld+json">{JSON.stringify(schemaData)}</script>;
}

export default SchemaOrg;
